<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fa fa-user-shield"></i> {{ "TITLE.PERMISSIONS" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="scrollable">
        <table class="table table-sm table-hover">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{ "TABLE.HEADER.MODULE" | translate }}</th>
            <th scope="col" class="custom-width-col1">{{ "TABLE.HEADER.PERMISSION" | translate }}</th>
            <th scope="col">{{ "TABLE.HEADER.DESCRIPTION" | translate }}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let authority of authorities; let index=index">
            <th scope="row">{{index + 1}}</th>
            <td>{{getModuleDescription(authority.module)}}</td>
            <td class="custom-width-col1 cw-433">
              <div class="custom-control custom-checkbox my-1 mr-sm-2">
                <input type="checkbox"
                       class="custom-control-input"
                       id="addRemoveCheckbox{{index}}"
                       [checked]="wasSelected(authority)"
                       (click)="addOrRemove($event, authority)"
                       [attr.disabled]="wasSelectedOnAuthoritiesByRol(authority) ? '' : null">
                <label class="custom-control-label" for="addRemoveCheckbox{{index}}">{{authority.code}}</label>
              </div>
            </td>
            <td>{{authority.description}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>

  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
